import { gql } from '../../__generated__/gql'

export const FOLLOW_CATEGORY_MUTATION = gql(`
  mutation communityFollowCategory($categoryId: Int!) {
    communityFollowCategory(input: {categoryId: $categoryId}) {
      user {
        id
        communityProfile {
          followCategories {
            id
            title
          }
        }
      }
    }
  }
`)
